import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./themes.css";
import App from "./App";

// Suppress the CRA dev "Uncaught runtime errors:" overlay for opaque cross-origin
// "Script error." entries. These come from browser extensions or 3rd-party scripts
// (Capacitor bridge, AdSense, etc.) where the browser strips the real message for
// security reasons. They are not actionable and they hide our actual UI. We keep
// the original error reported in the console for debugging.
window.addEventListener('error', (e) => {
  if (e && typeof e.message === 'string' && e.message.trim() === 'Script error.') {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
}, true);
window.addEventListener('unhandledrejection', (e) => {
  const msg = e?.reason?.message || String(e?.reason || '');
  if (msg.trim() === 'Script error.') {
    e.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
